import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem } from 'primeng/api';
import { Observable } from 'rxjs/Observable';
import { UserStoreDivision } from '../../../models/store-common.model';
import { StoreCommonService } from '../../../services/store/store-common.service';
import { UsersService } from '../../../services/user/users.service';
import { DivisionSalesNetworkService } from './../../../services/division-sales-network/divison-sales-network.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-user-store-division-form',
  templateUrl: './user-store-division-form.component.html',
  styles: ['label.required:after {top: 0}']
})
export class UserStoreDivisionFormComponent implements OnInit, OnChanges {

  @Output() onAddElement: EventEmitter<any> = new EventEmitter<any>();
  @Output() onUpdateElement: EventEmitter<any> = new EventEmitter<any>();
  @Input() editingElement: UserStoreDivision;
  addEditForm: FormGroup;
  validationData = null;
  user_items: SelectItem[];
  selected_user: any;
  selected_checkOnlyUser: any;
  division_items: SelectItem[];
  selected_division: any;
  store_items: SelectItem[];
  selected_store: SelectItem;
  validation: any;
  invalidSubmit: any;
  scope: SelectItem[] = [];
  catalogScope: string = '';
  notSpecifiedScope: string = '';
  filters: Array<{ key: string, value: string }>;

  flagAffiliatedUser: any;
  flg_use_preferred_store: any;

  message = {};

  constructor (
    private svc: StoreCommonService,
    private svcDivisionSalesNetwork: DivisionSalesNetworkService,
    private svcUsers: UsersService,
    private fb: FormBuilder,
    private translate: TranslateService,
    private messageService: MessageService,
  ) { }

  loadValidation() {
    this.svc.getUserStoreDivisionFields().subscribe(res => {
      this.validation = res
    })
  }

  loadCombos() {
    Observable.zip(this.svcUsers.getAll()
        .map(() => {
          if (this.svcUsers.users != null && this.svcUsers.users.length > 0) {
            return this.svcUsers.users;
          }
        })
      ,

      this.svcDivisionSalesNetwork.getSalesNetworkDivisionList()
        .map(() => {
          if (this.svcDivisionSalesNetwork.list_division != null && this.svcDivisionSalesNetwork.list_division.length > 0) {
            return this.svcDivisionSalesNetwork.list_division
          }
        }),

      this.svc.getList()
        .map(() => {
          if (this.svc.list_store != null && this.svc.list_store.length > 0) {
            return this.svc.list_store
          }
        })
    ).subscribe(() => {
        this.user_items = [ {
          value: null,
          label: ''
        }];

        this.svcUsers.users.forEach(u => {
          this.user_items.push({
            value: u.id,
            label: u.surname + ' ' + u.name
          })
        });

        this.division_items = [{
          label: '',
          value: -1
        }];

        this.svcDivisionSalesNetwork.list_division.forEach(d => {
          this.division_items.push({
            label: `${d.division_name} - ${d.sales_network_name}`,
            value: d.id
          })
        });

        this.store_items = [{
          label: '',
          value: -1
        }];
        this.svc.list_store.forEach(s => {
          this.store_items.push({
            label: `${s.code} - ${s.name}`,
            value: s.id
          })
        });
        this.selected_division = null;
        this.selected_store = null;
        this.selected_user = { label: this.editingElement.username, value: this.editingElement.user_id };
        this.flagAffiliatedUser = this.editingElement.flg_use_preferred_store == 1 ? true : false;
        if( (this.editingElement.division_id !=null && this.editingElement.store_id != null) || this.editingElement.division_id !=null){
          this.selected_division ={ label: this.editingElement.division_name, value: this.editingElement.division_sales_network_id };  //this.selected_checkOnlyStore = false ;
        }
        if( (this.editingElement.store_name !=null && this.editingElement.store_id != null) ){
          this.selected_store = { label: `${this.editingElement.store_host_code} - ${this.editingElement.store_name}`, value: this.editingElement.store_id };
        }
      }
    )

  }

  loadDivisionSalesNetwork() {

    this.division_items = [{
      label: '',
      value: -1
    }];

    this.svcDivisionSalesNetwork.list().subscribe(res => {
      for (let d of res) {
        this.division_items.push({
          label: d.division_name + ' - ' + d.sales_network_name,
          value: d.id
        })
      }
    });
  }

  loadScope(){
    this.scope.push({label: this.notSpecifiedScope, value: null});
    this.scope.push({label: "Loyalty", value: "loyalty"});
    this.scope.push({label: this.catalogScope, value: "catalog"});
  }

  ngOnInit(): void {

    this.translate.get([
      'reservations.catalog',
      'common.notSpecified'
    ]).subscribe(res =>{
      this.notSpecifiedScope = res['common.notSpecified'];
      this.catalogScope = res['reservations.catalog'];
    });
    this.loadCombos();
    this.loadDivisionSalesNetwork();
    this.loadValidation();
    this.loadScope();
    //if(this.editingElement.store_id != null)
      //this.selected_checkOnlyStore = true;
    if(this.editingElement.user_id != null)
      this.selected_checkOnlyUser = true;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.addEditForm = this.fb.group({
      'user_id': new FormControl(this.editingElement.user_id),
      'store_id': new FormControl(this.editingElement.store_id),
      'division_sales_network_id': new FormControl(this.editingElement.division_sales_network_id ),
      'scope': new FormControl(this.editingElement.scope),
      //'checkOnlyStore': new FormControl(this.checkOnlyStore),
      'flg_use_preferred_store': new FormControl(this.editingElement.flg_use_preferred_store),
    });
  }

  saveOrUpdate() {

    if (!this.addEditForm.valid) {
      this.invalidSubmit = true;
      return;
    }

    let newData = new UserStoreDivision();
    newData.id = this.editingElement.id;

    //casistica nuovo inserimento, check su almeno uno dei campi obbligatori tra store e division
    if(!this.selected_store && !this.selected_division){
      this.invalidSubmit = true;
      this.messageService.add({
        severity: 'error', 
        summary: this.translate.instant('common.error'),
        detail: this.translate.instant('common.obvFieldsUserStore')});
      return;
    } 
 
    if(this.selected_division && !this.selected_store)
      newData.division_sales_network_id = this.selected_division.value;
    if(this.selected_store)
      newData.store_id = this.selected_store.value;
    newData.user_id = this.selected_user.value;
    newData.scope = this.addEditForm.value.scope;
    newData.flg_use_preferred_store = this.flagAffiliatedUser == true ? 1 : 0;
    if (newData.id == null) {
      this.onAddElement.emit(newData);
    } else {
      this.onUpdateElement.emit(newData);
    }
  }
  getFilteredStores(event) {
    console.log(event.query)
    let params = [];
    if(this.filters) {
      this.filters.forEach(p => params.push(p));
    }
    console.log(params);
    if (event.query) {
      params.push({ 'key': 'store', 'value': event.query });
      this.svc.getStoreByStore(params).subscribe(res => {
        this.store_items = res.map(store => ({label: `${store.host_code} - ${store.name}`, value: `${store.id}`}))
      });
    } else {
      this.store_items = [{ label: '', value: -1}];
      this.svc.getStoreByStore(params).subscribe(res => {
        res.forEach(store => {
          if(store.name === undefined || store.name === null) {
            this.store_items.push({label: `${store.host_code} - --`, value: `${store.id}`})
          } else {
            this.store_items.push({label: `${store.host_code} - ${store.name}`, value: `${store.id}` })
          }
        });
      });
    }
  }

  getFilteredDivisionStores(event) {
    if (event.query) {
      /*this.svcDivisionSalesNetwork.getSalesNetworkDivisionListByName(event.query).subscribe(res =>
        res.forEach(d =>
        this.division_items.push({
          label: d.division_name + ' - ' + d.sales_network_name,
          value: d.id
        })));*/
        this.svcDivisionSalesNetwork.getSalesNetworkDivisionListByName(event.query).subscribe(res =>
          this.division_items = res
          );
    } else {
      this.division_items = [{
        label: '',
        value: -1
      }];
      //this.selected_checkOnlyStore = false;
      this.loadDivisionSalesNetwork();
    }
  }

  getFilteredUsers(event) {
    if (event.query) {
      this.svcUsers.getUserByNameSurnameUsername(event.query).subscribe(res => this.user_items = res);
      if(this.editingElement.user_id === null )
        this.selected_checkOnlyUser = true;
    } else {
      this.user_items = [{
        label: '',
        value: null
      }];
      this.selected_checkOnlyUser = false;
      this.svcUsers.getList().subscribe(users => users.map(user => this.user_items.push({label: `${user.login} - ${user.surname} ${user.name}`, value: `${user.id}`})))
    }
  }

  changeStore(event) {
    this.selected_store = event.value ? event : null;
    this.selected_division = null;
  }
  
}



// WEBPACK FOOTER //
// ./src/app/views/administration/user-store-division/user-store-division-form.component.ts